import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { getHashValue } from '@/utils/modifiers/getHashValue';

export const useDetectUrlHash = <T = string | undefined>(onDetectUrlHash: (hash: T) => void) => {
  const location = useLocation();
  const modalHash = getHashValue(location.hash) as T;

  useEffect(() => {
    if (modalHash) {
      window.history.replaceState('', document.title, window.location.pathname);
      onDetectUrlHash(modalHash);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
